// Some browsers/OS configurations do not report an IANA zone. Use an explicit
// UTC fallback for both the request and date picker, never the string "undefined".
export const resolveHistoryTimezone = (candidate) => {
  try {
    const zone = candidate || Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!zone || (zone !== 'UTC' && !zone.includes('/'))) return 'UTC';
    return (
      new Intl.DateTimeFormat('en', { timeZone: zone }).resolvedOptions()
        .timeZone || 'UTC'
    );
  } catch {
    return 'UTC';
  }
};

export const historyToday = (timezone = resolveHistoryTimezone()) => {
  const now = new Date();
  try {
    const parts = new Intl.DateTimeFormat('en', {
      timeZone: timezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(now);
    const get = (type) => parts.find((part) => part.type === type).value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  } catch {
    return now.toISOString().slice(0, 10);
  }
};
